import { Component } from 'react'
import qs from 'query-string'
import axios from 'axios'
import config from 'config'
import { setLmsCookie } from 'utils/auth'

class LmsHubConnect extends Component {
  componentDidMount() {
    this.handleLmsConnect()
  }

  lmsConnect = async (sessionToken, projectId, learnerId) => {
    const urlParams = new URLSearchParams({
      projectId,
      sessionToken,
      learnerId,
    })

    const url = `/auth/connections/lms?${urlParams.toString()}`

    const response = await axios
      .get(url, {
        baseURL: config.env.GRAPHQL_API_URL,
      })
      .catch(error => {
        throw error.response
      })

    return response
  }

  handleLmsConnect = async () => {
    const { projectId, sessionToken, learnerId, origin } = qs.parse(window.location.search)

    if (!projectId || !sessionToken || !learnerId) {
      // eslint-disable-next-line
      console.error('Missing required parameters: projectId, sessionToken, or learnerId')
      return
    }

    try {
      const response = await this.lmsConnect(sessionToken, projectId, learnerId)

      if (response.data && response.data.token) {
        setLmsCookie('lms-auth-token', response.data.token)

        const unowAuthData = {
          lmsAllowedOrigin: origin,
          lmsRelatedSessionId: response.data.session_id,
        }

        setLmsCookie('unow_auth_data', JSON.stringify(unowAuthData))

        window.location.href = response.data.continue_url
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error('LMS connection failed:', error)
    }
  }

  render() {
    return null
  }
}

LmsHubConnect.propTypes = {}

export default LmsHubConnect
